
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.614.61A2.153 2.153 0 012.097.024c.556 0 1.09.21 1.483.584l6.907 6.573L17.394.61c.193-.19.425-.342.68-.447a2.189 2.189 0 011.623-.013c.258.1.492.248.689.436.197.187.352.41.458.655a1.912 1.912 0 01-.014 1.544c-.11.243-.27.464-.47.648l-8.39 7.984a2.153 2.153 0 01-1.483.584c-.556 0-1.09-.21-1.483-.584L.614 3.432A1.948 1.948 0 010 2.02C0 1.49.22.984.614.609z","fill":"#282828"}})])
          )
        }
      }
    